import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
const AddSectionIcon = (t0)=>{
    const $ = c(10);
    const { width, height, color } = t0;
    let t1;
    let t2;
    let t3;
    if ($[0] !== color) {
        t1 = /*#__PURE__*/ jsx("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M15.5005 12C15.0034 12 14.6005 12.4029 14.6005 12.9V14.6001H12.9005C12.4034 14.6001 12.0005 15.003 12.0005 15.5001C12.0005 15.9972 12.4034 16.4001 12.9005 16.4001H14.6005V18.1C14.6005 18.5971 15.0034 19 15.5005 19C15.9975 19 16.4005 18.5971 16.4005 18.1V16.4001H18.1005C18.5975 16.4001 19.0005 15.9972 19.0005 15.5001C19.0005 15.003 18.5975 14.6001 18.1005 14.6001H16.4005V12.9C16.4005 12.4029 15.9975 12 15.5005 12Z",
            fill: color
        });
        t2 = /*#__PURE__*/ jsx("path", {
            d: "M17.0005 6.09961V7.90039L1.00049 7.90039L1.00049 6.09961L17.0005 6.09961Z",
            fill: color
        });
        t3 = /*#__PURE__*/ jsx("path", {
            d: "M16.2002 10V6.5C16.2002 5.50527 16.1993 4.81283 16.1553 4.27441C16.1121 3.74675 16.0323 3.44598 15.917 3.21973C15.6678 2.73077 15.2702 2.33323 14.7812 2.08398C14.5549 1.96867 14.2536 1.88786 13.7256 1.84473C13.1872 1.80076 12.4947 1.80078 11.5 1.80078H6.5C5.50527 1.80078 4.81283 1.80074 4.27441 1.84473C3.74671 1.88787 3.44599 1.9687 3.21973 2.08398C2.73075 2.33321 2.33321 2.73075 2.08398 3.21973C1.9687 3.44599 1.88787 3.74671 1.84473 4.27441C1.80074 4.81283 1.80078 5.50527 1.80078 6.5V11.5C1.80078 12.4947 1.80076 13.1872 1.84473 13.7256C1.88786 14.2536 1.96867 14.5549 2.08398 14.7812C2.33323 15.2702 2.73077 15.6678 3.21973 15.917C3.44598 16.0323 3.74675 16.1121 4.27441 16.1553C4.81283 16.1993 5.50527 16.2002 6.5 16.2002H9.50098L9.59277 16.2051C10.0465 16.2513 10.4004 16.6347 10.4004 17.1006C10.4003 17.5664 10.0464 17.9499 9.59277 17.9961L9.50098 18H6.5C5.53494 18 4.75663 18.0016 4.12793 17.9502C3.48889 17.898 2.92552 17.7865 2.40332 17.5205C1.57541 17.0987 0.901335 16.4256 0.479492 15.5977C0.213489 15.0754 0.102999 14.5112 0.0507816 13.8721C-0.000557147 13.2434 3.02744e-07 12.465 3.02744e-07 11.5V6.5C1.16357e-07 5.53494 -0.000585146 4.75663 0.0507816 4.12793C0.103006 3.48902 0.213595 2.92543 0.479492 2.40332C0.901335 1.57541 1.57541 0.901335 2.40332 0.479492C2.92543 0.213595 3.48902 0.103006 4.12793 0.0507816C4.75663 -0.000585079 5.53494 1.14747e-07 6.5 3.02751e-07H11.5C12.465 3.02751e-07 13.2434 -0.000557069 13.8721 0.0507816C14.5112 0.102999 15.0754 0.213489 15.5977 0.479492C16.4256 0.901335 17.0987 1.57541 17.5205 2.40332C17.7865 2.92552 17.898 3.48889 17.9502 4.12793C18.0016 4.75663 18 5.53494 18 6.5V10C18 10.497 17.5976 10.9003 17.1006 10.9004C16.6035 10.9004 16.2002 10.4971 16.2002 10Z",
            fill: color
        });
        $[0] = color;
        $[1] = t1;
        $[2] = t2;
        $[3] = t3;
    } else {
        t1 = $[1];
        t2 = $[2];
        t3 = $[3];
    }
    let t4;
    if ($[4] !== height || $[5] !== t1 || $[6] !== t2 || $[7] !== t3 || $[8] !== width) {
        t4 = /*#__PURE__*/ jsxs("svg", {
            viewBox: "0 0 20 20",
            width: width,
            height: height,
            children: [
                t1,
                t2,
                t3
            ]
        });
        $[4] = height;
        $[5] = t1;
        $[6] = t2;
        $[7] = t3;
        $[8] = width;
        $[9] = t4;
    } else t4 = $[9];
    return t4;
};
export { AddSectionIcon };
